import { FC } from 'react'
import { useIntl } from 'react-intl'
import { Link } from 'react-router'

import { Descriptions, Flex, Typography } from 'antd'

import dayjs from 'dayjs'

import { useCountries } from '../../components/country'
import { Country } from '../../components/icon/Country'
import { Title } from '../../components/text/Title'

type InformationProps = { data?: Maybe<RiderCardFragment> }

const Information: FC<InformationProps> = ({ data }) => {
  const { formatMessage } = useIntl()
  const { getNameByIso } = useCountries()

  return (
    <Flex vertical gap={16}>
      <Title style={{ marginBottom: 0 }} level={4}>
        {formatMessage({ id: 'rider.info' })}
      </Title>
      <Descriptions
        layout={'horizontal'}
        column={1}
        size={'small'}
        items={[
          {
            label: formatMessage({ id: 'rider.birth-date' }),
            children: data?.birthDate ? dayjs(data?.birthDate).format('DD MMMM, YYYY') : null,
          },
          {
            label: formatMessage({ id: 'rider.birth-place' }),
            children: data?.birthPlace ? (
              <Link
                target={'_blank'}
                to={`https://maps.google.com/?q=${[data?.birthPlace, data?.country ? getNameByIso(data.country) : ''].filter(Boolean).join(',')}`}
              >
                {data?.birthPlace}
              </Link>
            ) : null,
          },
          {
            label: formatMessage({ id: 'rider.country' }),
            children: data?.country ? (
              <Flex gap={8} align={'center'}>
                <Country height={16} country={data.country} />
                <Typography.Text ellipsis>{getNameByIso(data.country)}</Typography.Text>
              </Flex>
            ) : null,
          },
          {
            label: formatMessage({ id: 'rider.weight' }),
            children: data?.weight ? [data?.weight, 'кг'].join(' ') : '',
          },
          {
            label: formatMessage({ id: 'rider.height' }),
            children: data?.height ? [data?.height, 'см'].join(' ') : '',
          },
        ].filter((it) => !!it.children)}
      />
    </Flex>
  )
}

export { Information }
